import { render, staticRenderFns } from "./WTable.vue?vue&type=template&id=188b40e6&scoped=true&"
import script from "./WTable.vue?vue&type=script&lang=ts&"
export * from "./WTable.vue?vue&type=script&lang=ts&"
import style0 from "./WTable.vue?vue&type=style&index=0&id=188b40e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b40e6",
  null
  
)

export default component.exports